import PropTypes from 'prop-types';

import React from 'react';
import { List } from 'immutable';
import enhanceWithClickOutside from 'react-click-outside';

import SpellingDialogItem from '../SpellingDialogItem';
import Separator from '../ui/Separator';

import SpellingDialogStyled from './SpellingDialogStyled';

export class SpellingDialog extends React.PureComponent {
  handleClickOutside = () => {
    this.props.onClickOutside();
  }

  handleClick = (e) => {
    this.props.onSuggestionClick(e.target.innerText);
  };

  render() {
    return (
      <SpellingDialogStyled suppressContentEditableWarning>
        {this.props.suggestions.map(suggestion => (
          <SpellingDialogItem
            key={suggestion}
            text={suggestion}
            onClick={this.handleClick}
          />
        ))}

        <Separator />

        <SpellingDialogItem
          text="Пропустить все"
          onClick={this.props.onSkipAllClick}
        />
      </SpellingDialogStyled>
    );
  }
}

SpellingDialog.propTypes = {
  suggestions: PropTypes.instanceOf(List),
  onClickOutside: PropTypes.func,
  onSuggestionClick: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  onSkipAllClick: PropTypes.func,
};

export default enhanceWithClickOutside(SpellingDialog);
